// extracted by css-extract-rspack-plugin
export default {"widget":"oGjb4"};